import {
  ConversationTopicType,
  SupportRequestStatusType,
  SupportRequestTypeType,
} from "@/types/graphql/partner.generated";

/** Ключи локализации категорий диалога с помощником (conversations.topic.*). */
export const TOPIC_LABEL_KEY: Record<ConversationTopicType, string> = {
  [ConversationTopicType.PurchaseType]: "conversations.topic.purchase",
  [ConversationTopicType.AccessType]: "conversations.topic.access",
  [ConversationTopicType.PlaybackType]: "conversations.topic.playback",
  [ConversationTopicType.PaymentType]: "conversations.topic.payment",
  [ConversationTopicType.RefundType]: "conversations.topic.refund",
  [ConversationTopicType.AccountType]: "conversations.topic.account",
  [ConversationTopicType.OtherType]: "conversations.topic.other",
};

/** Ключи локализации типа обращения (requests.type.*). */
export const REQUEST_TYPE_LABEL_KEY: Record<SupportRequestTypeType, string> = {
  [SupportRequestTypeType.RefundType]: "requests.type.refund",
  [SupportRequestTypeType.AccessProblemType]: "requests.type.access",
  [SupportRequestTypeType.PaymentProblemType]: "requests.type.payment",
  [SupportRequestTypeType.OtherType]: "requests.type.other",
};

/**
 * Ключи локализации статуса обращения (requests.status.*). DRAFT и
 * CANCELLED партнёр не видит (обращение создаётся сразу OPEN, CANCELLED
 * ставит только зритель отменой), но `Record` по enum обязан покрыть весь
 * набор значений схемы, иначе TypeScript не даст завершить объект.
 */
export const REQUEST_STATUS_LABEL_KEY: Record<
  SupportRequestStatusType,
  string
> = {
  [SupportRequestStatusType.DraftType]: "requests.status.new",
  [SupportRequestStatusType.OpenType]: "requests.status.new",
  [SupportRequestStatusType.WaitingViewerType]: "requests.status.waitingViewer",
  [SupportRequestStatusType.ViewerRepliedType]: "requests.status.viewerReplied",
  [SupportRequestStatusType.ClosedType]: "requests.status.resolved",
  [SupportRequestStatusType.CancelledType]: "requests.status.resolved",
};
